export default __webpack_public_path__ + "static/media/train.3b5e7f8e.jpg";